import { useState, useEffect, Dispatch, SetStateAction } from "react";
import type { FC } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button } from "@mui/material";
import { showError } from "../helpers/toast";

export interface AddMuscleModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  title?: string;
  initialName?: string;
  onSubmit?: (name: string) => Promise<void> | void;
  isSubmitting?: boolean;
}

const AddMuscleModal: FC<AddMuscleModalProps> = ({
  open,
  onClose,
  setOpen,
  title,
  initialName = "",
  onSubmit,
  isSubmitting,
}) => {
  const [muscle, setMuscle] = useState(initialName);
  const [error, setError] = useState(false);

  const heading = title || "Add Muscle Group";
  const fieldLabel =
    heading.toLowerCase().startsWith("add ")
      ? heading.slice(4)
      : heading;

  useEffect(() => {
    if (open) {
      setMuscle(initialName || "");
      setError(false);
    }
  }, [open, initialName]);

  const handleSubmit = async () => {
    setError(true);
    const trimmed = muscle.trim();
    if (!trimmed) return;

    try {
      await onSubmit?.(trimmed);
      setError(false);
      setOpen(false);
    } catch (err: any) {
      showError(err?.response?.data?.message || err?.message || "Failed to submit");
    }
  };

  return (
    <Modal
      className="modal addNotification_modal"
      open={open}
      onClose={() => {
        onClose();
        setError(false);
      }}
    >
      <div className="modal-dialog">
        <div className="modal-body">

          {/* Title */}
          <div className="modal_title">
            <h2>{heading}</h2>
            <button
              type="button"
              className="btn-close"
              onClick={() => setOpen(false)}
            >
              <CloseIcon />
            </button>
          </div>

          {/* Form */}
          <form className="form">
            <div className="control_group">
              <TextField
                placeholder={`${fieldLabel} Name`}
                fullWidth
                hiddenLabel
                value={muscle}
                onChange={(e) => setMuscle(e.target.value)}
              />
              {error && muscle === "" && (
                <h6 className="err_msg">{`${fieldLabel} name is required`}</h6>
              )}
            </div>

            {/* Footer */}
            <div className="footer_btn_flex">
              <Button
                className="btn btn_grey"
                onClick={() => {
                  setError(false);
                  setOpen(false);
                }}
              >
                Cancel
              </Button>

              <Button
                className="btn btn_primary"
                onClick={handleSubmit}
                disabled={isSubmitting}
              >
                {isSubmitting ? "Saving..." : "Submit"}
              </Button>
            </div>
          </form>

        </div>
      </div>
    </Modal>
  );
};

export default AddMuscleModal;
